import { Scene } from "../../tools/Scene";

export class FpsCounterScene extends Scene{

    x:number;
    y:number;
    fpsText:Phaser.GameObjects.Text|null = null;

    constructor(sceneConfig,x:number,y:number){
        super(sceneConfig);
        this.x = x;
        this.y = y;
    }

    prescaleCreate(){
        let position = this.scaleManager.getRelativePosition(this.x,this.y,false);
        let style = { fontFamily: 'Arial',fontSize: 16, color: '#FFFFFF'};
        this.fpsText = this.add.text(position.x,position.y,'FPS: Not Counting',style);
        this.fpsText.setOrigin(this.x,this.y);
        this.fpsText.visible = false;
    }

    reorient(landscape:boolean):void {
        let position = this.scaleManager.getRelativePosition(this.x,this.y,false);
        this.fpsText!.setPosition(position.x,position.y);
    }

    update(timestep,dt){
        if(this.fpsText){
            this.fpsText.setText(`FPS: ${(1.0 / dt * 1000).toFixed()}`);
            this.scene.bringToTop(this.scene.settings.key);
        }
    }
}